export const ACTIVE = "fra-state-active";
export const LOADING = "fra-state-loading";
export const LOADED = "fra-state-loaded";
export const EXPANDED = "fra-state-expanded";
export const ERROR = "fra-state-error";
export const HIDDEN = "fra-state-hidden";
export const VISIBLE = "fra-state-visible";
export const INVISIBLE = "fra-state-invisible";
export const INACTIVE = "fra-state-inactive";
export const UNSTARTED = "fra-state-unstarted";
export const SCROLL_LOCK = "fra-state-hidden-overflow";
export const ANIMATING = "fra-state-animating";
export const STATE_PREFIX = "fra-state-";
export const TOUCH = "fra-h-touch";
export const NO_TOUCH = "fra-h-no-touch";
export const INVERTED = "fra-h-inverted";
export const IN_VIEWPORT = "fra-state-invp";
export const DRAGGING = "fra-state-dragging";
export const DISABLED = "fra-state-disabled";
export const SELECTED = "fra-state-selected";
export const HASCOOKIE = "fra-state-has-cookie";
export const INITIALIZED = "fra-state-initialized";
export const OPEN = "fra-state-open";
export const OVERLAY_OPEN = "fra-state-overlay-open";
export const SUCCESS = "fra-state-success";
export const PLAYING = "fra-state-playing";
export const STICKY = "fra-state-sticky";
export const VALID = "fra-state-valid";
export const INVALID = "fra-state-invalid";
export const RANGE = "fra-state-range";
